module.exports = __webpack_public_path__ + "img/edit_32.b43e8c6a.svg";